import {Component, Inject} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheet} from '@angular/material/bottom-sheet';
import {TranslocoPipe} from '@jsverse/transloco';
import {MatDivider} from '@angular/material/divider';
import {MatFabButton} from '@angular/material/button';
import {NgOptimizedImage} from '@angular/common';
import {
  ClosableBottomSheetHandleComponent
} from '../closable-bottom-sheet/closable-bottom-sheet-handle/closable-bottom-sheet-handle.component';
import {ClosableBottomSheetComponent} from '../closable-bottom-sheet/closable-bottom-sheet.component';
import {Campaign, locationDisplayFunction} from '../../services/model';
import {openMapApp} from '../../utils/maps-utils';

@Component({
  selector: 'app-campaign-locations-list',
  imports: [
    ClosableBottomSheetHandleComponent,
    TranslocoPipe,
    MatDivider,
    NgOptimizedImage,
    MatFabButton,
  ],
  templateUrl: './campaign-locations-list.component.html',
  styleUrl: './campaign-locations-list.component.scss'
})
export class CampaignLocationsListComponent extends ClosableBottomSheetComponent {

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public campaign: Campaign, bottomSheet: MatBottomSheet) {
    super(bottomSheet);
  }

  protected readonly locationDisplayFunction = locationDisplayFunction;

  protected readonly openMapApp = openMapApp;
}
